<div class="lsq-input lsq-search lsq-autocomplete">
    <lsq-input
        #inputElement
        [name]="name"
        [label]="label"
        [control]="getControl()"
        [group]="group"
        [basicLabel]="basicLabel"
        [floatLabel]="floatLabel"
        [innerLabel]="innerLabel"
        [parentClass]="parentClass"
        [inputClass]="inputClass"
        [labelClass]="labelClass"
        [autoFocus]="autoFocus"
        [placeholder]="placeholder ? placeholder : ''"
        (keydown)="handleViewportKeypress($event)"
        (inputValueChanged)="handleInputValueChanged($event)"
        (focus)="setFocus(true)"
        (blur)="setFocus(false)"
    >
        <ng-template #dropdownViewport>
            <lsq-dropdown [show]="options?.length > 0" [triangle]="false">
                <ng-scrollbar #scrollBarRef>
                    <ul class="lsq-dropdown-list list-unstyled" #dropdownMenuRef>
                        <li
                            #optionRefs
                            *ngFor="let option of options; let i = index"
                            [ngClass]="{ selected: i === highlightedOptionIndex }"
                            class="lsq-dropdown-item dropdown-item"
                            (mousedown)="selectItem(option)"
                        >
                            <p>{{ option.label }}</p>
                            <h5>{{ option.subLabel }}</h5>
                        </li>
                    </ul>
                </ng-scrollbar>
            </lsq-dropdown>
        </ng-template>
    </lsq-input>
</div>
<div #map></div>
